namespace GeniuzPOS.Inventory {
    export interface IcStockTranferData extends Serenity.ListRequest {
        Header?: IcStockTransferRow;
        Details?: IcStockTransferDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
